import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { IsNullOrEmpty } from "../../helpers/NullEmptyHelpers";
import "./SharedSiteDown.css";

const SharedSiteDown = ({ onRetry }) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    if (onRetry) {
      onRetry();
    }
    navigate("/");
  };

  const siteDownTitle =
    process.env.REACT_APP_SITE_DOWN_TITLE || "Service Temporarily Unavailable";
  const siteDownMessage =
    process.env.REACT_APP_SITE_DOWN_MESSAGE ||
    "We're sorry, but the service is currently unavailable. This may be due to maintenance or a temporary issue.";
  const siteDownInstruction =
    process.env.REACT_APP_SITE_DOWN_INSTRUCTION ||
    "Please try again in a few moments. If the problem persists, please contact support.";
  const siteDownButtonText =
    process.env.REACT_APP_SITE_DOWN_BUTTON_TEXT || "Return to Homepage";

  return (
    <Container className="site-down-container">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col xs={12} md={8} lg={6} className="text-center">
          <div className="site-down-content">
            <i className="fa fa-exclamation-triangle site-down-icon mb-4"></i>
            <h1 className="mb-3">{siteDownTitle}</h1>
            <p className="lead mb-4">{siteDownMessage}</p>
            <p className="mb-4">{siteDownInstruction}</p>
            {!IsNullOrEmpty(siteDownButtonText) ? (
              <Button
                variant="primary"
                size="lg"
                onClick={handleHomeClick}
                className="mt-3"
              >
                <i className="fa fa-home me-2"></i>
                {siteDownButtonText}
              </Button>
            ) : null}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SharedSiteDown;
